import { useContext } from "react";
import { LastActivityContext, LastActivityContextType } from "../contexts/lastActivity";

export const useLastActivity = (): LastActivityContextType => {
  return useContext(LastActivityContext);
};
